import { render } from "./MdTextarea.vue?vue&type=template&id=a6206876"
import script from "./MdTextarea.vue?vue&type=script&lang=js"
export * from "./MdTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.41_vue@3.5.14_typescript@5.5.4__webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__